// The public https origin of the web app, used for Stripe return URLs.
// A native WebView's own origin is not a navigable https URL, so the
// configured value (default https://app.maxflow.io) applies there.

import { isNativePlatform } from '@/platform/detection'

const DEFAULT_APP_BASE_URL = 'https://app.maxflow.io'

export function getAppBaseUrl(): string {
  const configured = import.meta.env.VITE_APP_BASE_URL
  if (configured) return configured.replace(/\/+$/, '')
  return isNativePlatform() ? DEFAULT_APP_BASE_URL : window.location.origin
}

/** Absolute URL of an in-app `path` (leading slash). */
export function appUrl(path: string): string {
  return `${getAppBaseUrl()}${path}`
}
